export class AnalyticsDashboardDb {
    public static widgets = {
        widget1: {
            chartType: 'line',
            datasets: {
                '2016': [
                    {
                        label: 'Sales',
                        data: [1.9, 3, 3.4, 2.2, 2.9, 3.9, 2.5, 3.8, 4.1, 3.8, 3.2, 2.9],
                        fill: 'start'

                    }
                ],
                '2017': [
                    {
                        label: 'Sales',
                        data: [2.2, 2.9, 3.9, 2.5, 3.8, 3.2, 2.9, 1.9, 3, 3.4, 4.1, 3.8],
                        fill: 'start'

                    }
                ],
                '2018': [
                    {
                        label: 'Sales',
                        data: [3.9, 2.5, 3.8, 4.1, 1.9, 3, 3.8, 3.2, 2.9, 3.4, 2.2, 2.9],
                        fill: 'start'

                    }
                ]

            },
            labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
            colors: [
                {
                    borderColor: '#42a5f5',
                    backgroundColor: '#42a5f5',
                    pointBackgroundColor: '#1e88e5',
                    pointHoverBackgroundColor: '#1e88e5',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 32,
                        left: 32,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    },
                    line: {
                        tension: 0
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                                drawBorder: false,
                                tickMarkLength: 18
                            },
                            ticks: {
                                fontColor: '#ffffff'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                            ticks: {
                                min: 1.5,
                                max: 5,
                                stepSize: 0.5
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    },
                    xLabelsOnTop: {
                        active: true
                    }
                }
            }
        },
        widget2: {
            conversion: {
                value: 10458,
                ofTarget: 5
            },
        },
        widget3: {
            impressions: {
                value: 10,
                ofTarget: 10
            },
        },
        widget10: {
            impressions: {
                value: 'R$2.021.458,86',
                ofTarget: 15
            },
            chartType: 'line',
            datasets: [
                {
                    label: 'Impression',
                    data: [67000, 54000, 82000, 57000, 72000, 57000, 87000, 72000, 89000, 98700, 112000, 136000, 110000, 149000, 98000],
                    fill: false
                }
            ],
            labels: ['Jan 1', 'Jan 2', 'Jan 3', 'Jan 4', 'Jan 5', 'Jan 6', 'Jan 7', 'Jan 8', 'Jan 9', 'Jan 10', 'Jan 11', 'Jan 12', 'Jan 13', 'Jan 14', 'Jan 15'],
            colors: [
                {
                    borderColor: '#5c84f1'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 2,
                        borderWidth: 1,
                        hoverRadius: 2,
                        hoverBorderWidth: 1
                    },
                    line: {
                        tension: 0
                    }
                },
                layout: {
                    padding: {
                        top: 24,
                        left: 16,
                        right: 16,
                        bottom: 16
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: false
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                            ticks: {
                                // min: 100,
                                // max: 500
                            }
                        }
                    ]
                }
            }
        },
        widget11: {
            chartType: 'line',
            datasets: [
                {
                    label: 'A2W PLATAFORMA DEMO - ALFENAS',
                    data: [121, 450, 10, 230, 600],
                    fill: false
                },
                {
                    label: 'A2W PLATAFORMA DEMO - ANDRADAS',
                    data: [35, 117, 94, 351, 467],
                    fill: false
                },
                {
                    label: 'A2W PLATAFORMA DEMO - BOM REPOUSO',
                    data: [150, 285, 36, 99, 122],
                    fill: false
                },
                {
                    label: 'A2W PLATAFORMA DEMO - MATRIZ',
                    data: [119, 275, 340, 900, 1200],
                    fill: false
                },
                {
                    label: 'A2W PLATAFORMA DEMO - BRAGANCA',
                    data: [450, 100, 230, 350, 198],
                    fill: false
                },
                {
                    label: 'A2W PLATAFORMA DEMO - CAMPESTRE',
                    data: [27, 39, 119, 210, 165],
                    fill: false
                }
            ],
            labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai'],
            colors: [
                {
                    borderColor: '#63c08c',
                    backgroundColor: '#63c08c',
                    pointBackgroundColor: '#63c08c',
                    pointHoverBackgroundColor: '#63c08c',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#f58220',
                    backgroundColor: '#f58220',
                    pointBackgroundColor: '#f58220',
                    pointHoverBackgroundColor: '#f58220',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#1976d2',
                    backgroundColor: '#1976d2',
                    pointBackgroundColor: '#1976d2',
                    pointHoverBackgroundColor: '#1976d2',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#2e3092',
                    backgroundColor: '#2e3092',
                    pointBackgroundColor: '#2e3092',
                    pointHoverBackgroundColor: '#2e3092',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 2,
                        borderWidth: 1,
                        hoverRadius: 2,
                        hoverBorderWidth: 1
                    },
                    line: {
                        tension: 0
                    }
                },
                layout: {
                    padding: {
                        top: 24,
                        left: 16,
                        right: 16,
                        bottom: 16
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: true
                        }
                    ],
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                // min: 100,
                                // max: 500
                            }
                        }
                    ]
                }
            }
        },
        widget4: {
            visits: {
                value: '50%',
                ofTarget: -3
            }
        },
        widget5: {
            chartType: 'bar',
            datasets: [

                {
                    label: 'Pendente',
                    data: [371],
                    fill: 'start'
                },
                {
                    label: 'Aprovado',
                    data: [920],
                    fill: 'start'

                },
                {
                    label: 'Faturado Parcial',
                    data: [127],
                    fill: 'start'

                },
                {
                    label: 'Faturado Total',
                    data: [1472],
                    fill: 'start'

                }
            ],
            labels: ['Status'],
            colors: [
                {
                    borderColor: '#1882ff',
                    backgroundColor: '#1882ff',
                    pointBackgroundColor: '#1882ff',
                    pointHoverBackgroundColor: '#1882ff',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#63c08c',
                    backgroundColor: '#63c08c',
                    pointBackgroundColor: '#63c08c',
                    pointHoverBackgroundColor: '#63c08c',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: true,
                responsive: true,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)',
                                min: 0
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 50000,
                                min: 0
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget12: {
            chartType: 'horizontalBar',
            datasets: [
                {
                    label: 'Vendas',
                    data: [5621, 5431, 5212, 4871, 4562, 4310, 4021, 3600, 2709, 1979],
                    fill: 'start'
                }
            ],
            labels: [
                'FERTILIZANTE 19.04.19',
                'FERTILIZANTE F 00.00.58 KCL FR',
                'VERDADERO 600WG (1KG)',
                'VERDADERO 600WG (5KG)',
                'PRODUTO 5',
                'PRODUTO 6',
                'PRODUTO 7',
                'PRODUTO 8',
                'PRODUTO 9',
                'PRODUTO 10'],
            colors: [
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)',
                                min: 0
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 1000,
                                min: 0
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget16: {
            chartType: 'horizontalBar',
            datasets: [
                {
                    label: 'Vendas',
                    data: [3256, 8568, 15246, 1254, 5426],
                    fill: 'start'
                }
            ],
            labels: ['Vendedor A', 'Vendedor B', 'Vendedor C', 'Vendedor D', 'Vendedor E'],
            colors: [
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)',
                                min: 0
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 1000,
                                min: 0
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget17: {
            chartType: 'horizontalBar',
            datasets: [
                {
                    label: 'Vendas',
                    data: [21201, 25642, 35624, 15245, 26354],
                    fill: 'start'
                }
            ],
            labels: ['Cliente A', 'Cliente B', 'Cliente C', 'Cliente D', 'Cliente E'],
            colors: [
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)',
                                min: 0
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 10000,
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget15: {
            chartType: 'bar',
            datasets: [

                {
                    label: 'Pedidos Efetuados',
                    data: [3000, 3400, 4100, 3800, 2200],
                    fill: 'start'
                },
                {
                    label: 'Pedidos Entregues',
                    data: [2500, 3400, 3600, 4500, 1900],
                    fill: 'start'
                },
                {
                    label: 'Pedidos Pendentes',
                    data: [500, 500, 1000, 300, 600],
                    fill: 'start'
                }
            ],
            labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai'],
            colors: [
                {
                    borderColor: '#1882ff',
                    backgroundColor: '#1882ff',
                    pointBackgroundColor: '#1882ff',
                    pointHoverBackgroundColor: '#1882ff',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#63c08c',
                    backgroundColor: '#63c08c',
                    pointBackgroundColor: '#63c08c',
                    pointHoverBackgroundColor: '#63c08c',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#54c5cf',
                    backgroundColor: '#54c5cf',
                    pointBackgroundColor: '#54c5cf',
                    pointHoverBackgroundColor: '#54c5cf',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 1000
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget6: {
            markers: [
                {
                    lat: 52,
                    lng: -73,
                    label: '120'
                },
                {
                    lat: 37,
                    lng: -104,
                    label: '498'
                },
                {
                    lat: 21,
                    lng: -7,
                    label: '443'
                },
                {
                    lat: 55,
                    lng: 75,
                    label: '332'
                },
                {
                    lat: 51,
                    lng: 7,
                    label: '50'
                },
                {
                    lat: 31,
                    lng: 12,
                    label: '221'
                },
                {
                    lat: 45,
                    lng: 44,
                    label: '455'
                },
                {
                    lat: -26,
                    lng: 134,
                    label: '231'
                },
                {
                    lat: -9,
                    lng: -60,
                    label: '67'
                },
                {
                    lat: 33,
                    lng: 104,
                    label: '665'
                }
            ],
            styles: [
                {
                    'featureType': 'administrative',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#444444'
                        }
                    ]
                },
                {
                    'featureType': 'landscape',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'color': '#f2f2f2'
                        }
                    ]
                },
                {
                    'featureType': 'poi',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'visibility': 'off'
                        }
                    ]
                },
                {
                    'featureType': 'road',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'saturation': -100
                        },
                        {
                            'lightness': 45
                        }
                    ]
                },
                {
                    'featureType': 'road.highway',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'visibility': 'simplified'
                        }
                    ]
                },
                {
                    'featureType': 'road.arterial',
                    'elementType': 'labels.icon',
                    'stylers': [
                        {
                            'visibility': 'off'
                        }
                    ]
                },
                {
                    'featureType': 'transit',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'visibility': 'off'
                        }
                    ]
                },
                {
                    'featureType': 'water',
                    'elementType': 'all',
                    'stylers': [
                        {
                            'color': '#039be5'
                        },
                        {
                            'visibility': 'on'
                        }
                    ]
                }
            ]
        },
        widget13: {
            chartType: 'line',
            datasets: [

                {
                    label: 'Vendas realizadas',
                    data: [15264, 8546, 5426, 7854, 12356],
                    fill: 'start'
                },
                {
                    label: 'Vendas provisionadas',
                    data: [9584, 12546, 6584, 4256, 9548],
                    fill: 'start'

                }
            ],
            labels: ['2020/1', '2019/2', '2019/1', '2018/2', '2018/1'],
            colors: [
                {
                    borderColor: '#40a1a7',
                    backgroundColor: '#40a1a7',
                    pointBackgroundColor: '#40a1a7',
                    pointHoverBackgroundColor: '#40a1a7',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#63c08c',
                    backgroundColor: '#63c08c',
                    pointBackgroundColor: '#63c08c',
                    pointHoverBackgroundColor: '#63c08c',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false
                },
                layout: {
                    padding: {
                        left: 24,
                        right: 32
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        borderWidth: 2,
                        hoverRadius: 4,
                        hoverBorderWidth: 2
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: 'rgba(0,0,0,0.54)'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                tickMarkLength: 16
                            },
                            ticks: {
                                stepSize: 1000
                            }
                        }
                    ]
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                }
            }
        },
        widget7: {
            scheme: {
                domain: ['#4867d2', '#5c84f1', '#89a9f4']
            },
            devices: [
                {
                    name: 'Desktop',
                    value: 92.8,
                    change: -0.6
                },
                {
                    name: 'Mobile',
                    value: 6.1,
                    change: 0.7
                },
                {
                    name: 'Tablet',
                    value: 1.1,
                    change: 0.1
                }
            ]
        },
        widget14: {
            chartType: 'line',
            datasets: [
                {
                    label: 'Unidade 1',
                    data: [20, 45, 52, 35, 120],
                    fill: false
                },
                {
                    label: 'Unidade 2',
                    data: [60, 78, 12, 85, 60],
                    fill: false
                },
                {
                    label: 'Unidade 3',
                    data: [50, 95, 64, 78, 185],
                    fill: false
                }
            ],
            labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai'],
            colors: [
                {
                    borderColor: '#62b886',
                    backgroundColor: '#62b886',
                    pointBackgroundColor: '#62b886',
                    pointHoverBackgroundColor: '#62b886',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#2e3092',
                    backgroundColor: '#2e3092',
                    pointBackgroundColor: '#2e3092',
                    pointHoverBackgroundColor: '#2e3092',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#f58220',
                    backgroundColor: '#f58220',
                    pointBackgroundColor: '#f58220',
                    pointHoverBackgroundColor: '#f58220',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                },
                {
                    borderColor: '#1976d2',
                    backgroundColor: '#1976d2',
                    pointBackgroundColor: '#1976d2',
                    pointHoverBackgroundColor: '#1976d2',
                    pointBorderColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff'
                }
            ],
            options: {
                spanGaps: false,
                legend: {
                    display: true
                },
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 2,
                        borderWidth: 1,
                        hoverRadius: 2,
                        hoverBorderWidth: 1
                    },
                    line: {
                        tension: 0
                    }
                },
                layout: {
                    padding: {
                        top: 24,
                        left: 16,
                        right: 16,
                        bottom: 16
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: true
                        }
                    ],
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                // min: 100,
                                // max: 500
                            }
                        }
                    ]
                }
            }
        },
        widget18: {
            title: 'Produtos mais vendidos',
            ranges: {
                'TW': 'Filtro 1',
                'LW': 'Filtro 2',
                '2W': 'Filtro 3'
            },
            mainChart: {
                'TW': [
                    {
                        'name': 'Produto A',
                        'value': 1524
                    },
                    {
                        'name': 'Produto B',
                        'value': 854
                    },
                    {
                        'name': 'Produto C',
                        'value': 265
                    },
                    {
                        'name': 'Produto D',
                        'value': 452
                    }
                ],
                'LW': [
                    {
                        'name': 'Produto A',
                        'value': 754
                    },
                    {
                        'name': 'Produto B',
                        'value': 215
                    },
                    {
                        'name': 'Produto C',
                        'value': 462
                    },
                    {
                        'name': 'Produto D',
                        'value': 125
                    }
                ],
                '2W': [
                    {
                        'name': 'Produto A',
                        'value': 564
                    },
                    {
                        'name': 'Produto B',
                        'value': 254
                    },
                    {
                        'name': 'Produto C',
                        'value': 325
                    },
                    {
                        'name': 'Produto D',
                        'value': 102
                    }
                ]
            },
            scheme: {
                domain: ['#1976d2', '#40a1a7', '#a5e348', '#806a63', '#2e3092']
            }
        },
        widget19: {
            title: 'Área de atuação dos clientes',
            ranges: {
                'TW': 'Filtro 1',
                'LW': 'Filtro 2',
                '2W': 'Filtro 3'
            },
            mainChart: {
                'TW': [
                    {
                        'name': 'Vendedor A',
                        'value': 239
                    },
                    {
                        'name': 'Vendedor B',
                        'value': 221
                    },
                    {
                        'name': 'Vendedor C',
                        'value': 194
                    },
                    {
                        'name': 'Vendedor D',
                        'value': 168
                    },
                    {
                        'name': 'Vendedor E',
                        'value': 147
                    }
                ],
                'LW': [
                    {
                        'name': 'Café',
                        'value': 45
                    },
                    {
                        'name': 'Soja',
                        'value': 30
                    },
                    {
                        'name': 'Milho',
                        'value': 15
                    },
                    {
                        'name': 'Feijão',
                        'value': 8
                    },
                    {
                        'name': 'Arroz',
                        'value': 2
                    }
                ],
                '2W': [
                    {
                        'name': 'Café',
                        'value': 70
                    },
                    {
                        'name': 'Soja',
                        'value': 10
                    },
                    {
                        'name': 'Milho',
                        'value': 15
                    },
                    {
                        'name': 'Feijão',
                        'value': 3
                    },
                    {
                        'name': 'Arroz',
                        'value': 2
                    }
                ]
            },
        },
        widget199: {
            title: 'Área de atuação dos clientes',
            ranges: {
                'TW': 'Filtro 1',
                'LW': 'Filtro 2',
                '2W': 'Filtro 3'
            },
            mainChart: {
                'TW': [
                    {
                        'name': 'Cliente A',
                        'value': 9
                    },
                    {
                        'name': 'Cliente B',
                        'value': 7
                    },
                    {
                        'name': 'Cliente C',
                        'value': 7
                    },
                    {
                        'name': 'Cliente D',
                        'value': 6
                    },
                    {
                        'name': 'Cliente E',
                        'value': 5
                    }
                ],
                'LW': [
                    {
                        'name': 'Café',
                        'value': 45
                    },
                    {
                        'name': 'Soja',
                        'value': 30
                    },
                    {
                        'name': 'Milho',
                        'value': 15
                    },
                    {
                        'name': 'Feijão',
                        'value': 8
                    },
                    {
                        'name': 'Arroz',
                        'value': 2
                    }
                ],
                '2W': [
                    {
                        'name': 'Café',
                        'value': 70
                    },
                    {
                        'name': 'Soja',
                        'value': 10
                    },
                    {
                        'name': 'Milho',
                        'value': 15
                    },
                    {
                        'name': 'Feijão',
                        'value': 3
                    },
                    {
                        'name': 'Arroz',
                        'value': 2
                    }
                ]
            },
        },
        widget8: {
            scheme: {
                domain: ['#5c84f1']
            },
            today: '12,540',
            change: {
                value: 321,
                percentage: 2.05
            },
            data: [
                {
                    name: 'Sales',
                    series: [
                        {
                            name: 'Jan 1',
                            value: 540
                        },
                        {
                            name: 'Jan 2',
                            value: 539
                        },
                        {
                            name: 'Jan 3',
                            value: 538
                        },
                        {
                            name: 'Jan 4',
                            value: 539
                        },
                        {
                            name: 'Jan 5',
                            value: 540
                        },
                        {
                            name: 'Jan 6',
                            value: 539
                        },
                        {
                            name: 'Jan 7',
                            value: 540
                        }
                    ]
                }
            ],
            dataMin: 538,
            dataMax: 541
        },
        widget9: {
            rows: [
                {
                    title: 'Holiday Travel',
                    clicks: 3621,
                    conversion: 90
                },
                {
                    title: 'Get Away Deals',
                    clicks: 703,
                    conversion: 7
                },
                {
                    title: 'Airfare',
                    clicks: 532,
                    conversion: 0
                },
                {
                    title: 'Vacation',
                    clicks: 201,
                    conversion: 8
                },
                {
                    title: 'Hotels',
                    clicks: 94,
                    conversion: 4
                }
            ]
        }
    };
}
